module.exports = __webpack_public_path__ + "img/banner.b7d0a28a.jpg";